import { Color as ColorType } from 'components/VisualStudioPlayground/VisualEditor/Types'
import Color from 'colorjs.io'

const LUMUNANCE_AMOUNT = 30

export const getDefaultColor = (color: ColorType): ColorType => {
  if (color.type === 'solidColor') {
    let newColor: Color
    const hsl = new Color(color.color).to('hsl').coords

    let [h, s, l] = hsl
    if (isNaN(h)) h = 0 // In the extreme cases of #FFF and #000, hsl() returns NaN for h

    if (l > LUMUNANCE_AMOUNT) {
      newColor = new Color(`hsl(${h}, ${s}%, ${l - LUMUNANCE_AMOUNT}%)`).to('srgb')
    } else {
      newColor = new Color(`hsl(${h}, ${s}%, ${l + LUMUNANCE_AMOUNT}%)`).to('srgb')
    }

    return {
      type: 'linearGradient',
      angle: 0,
      stops: [
        { color: color.color, position: 0, opacity: color.opacity },
        { color: newColor.toString({ format: 'hex' }), position: 1, opacity: color.opacity },
      ],
    }
  } else {
    return { type: 'solidColor', color: color.stops[0].color, opacity: color.stops[0].opacity }
  }
}
